import { defineMessages } from 'react-intl';

export const userMessages = defineMessages({
    user: {
        id: 'user',
        defaultMessage: 'User',
    },
    users: {
        id: 'users',
        defaultMessage: 'Users',
    },
    name: {
        id: 'name',
        defaultMessage: 'Name',
    },
    email: {
        id: 'email',
        defaultMessage: 'Email',
    },
    active: {
        id: 'active',
        defaultMessage: 'Active',
    },
    roles: {
        id: 'roles',
        defaultMessage: 'Roles',
    },
    createUserSuccess: {
        id: 'create-user-success',
        defaultMessage: 'User created',
    },
    updateUserSuccess: {
        id: 'update-user-success',
        defaultMessage: 'User updated',
    },
    createUserSuccessDescription: {
        id: 'create-user-success-description',
        defaultMessage: 'User {entry} has been successfully created.',
    },
    updateUserSuccessDescription: {
        id: 'update-user-success-description',
        defaultMessage: 'User {entry} has been successfully updated.',
    },
    addUser: {
        id: 'add-user',
        defaultMessage: 'Add user',
    },
    addUserSubtitle: {
        id: 'add-user-subtitle',
        defaultMessage: 'Add new user',
    },
    editUserSubtitle: {
        id: 'edit-user-subtitle',
        defaultMessage: 'Edit user {entry}',
    },
    activateUser: {
        id: 'activate-user',
        defaultMessage: 'Activate',
    },
    activateUserSubtitle: {
        id: 'activate-user-subtitle',
        defaultMessage: 'Activate user {entry}',
    },
    confirmActivateUser: {
        id: 'confirm-activate-user',
        defaultMessage: 'Are you sure you want to activate user {entry}?',
    },
    userActivationSuccess: {
        id: 'user-activation-success',
        defaultMessage: 'The user was activated',
    },
    userActivationSuccessDescription: {
        id: 'user-activation-success-description',
        defaultMessage: 'The user {entry} was successfully activated.',
    },
    deactivateUser: {
        id: 'deactivate-user',
        defaultMessage: 'Deactivate',
    },
    deactivateUserSubtitle: {
        id: 'deactivate-user-subtitle',
        defaultMessage: 'Deactivate user {entry}',
    },
    confirmDeactivateUser: {
        id: 'confirm-deactivate-user',
        defaultMessage: 'Are you sure you want to deactivate user {entry}?',
    },
    userDeactivationSuccess: {
        id: 'user-deactivation-success',
        defaultMessage: 'The user was deactivated',
    },
    userDeactivationSuccessDescription: {
        id: 'user-deactivation-success-description',
        defaultMessage: 'The user {entry} was successfully deactivated.',
    },
    searchUser: {
        id: 'search-user',
        defaultMessage: 'Search user',
    },
    noUser: {
        id: 'no-user',
        defaultMessage: 'No user',
    },
    noUserFound: {
        id: 'no-user-found',
        defaultMessage: 'No user found',
    },
    deactivated: {
        id: 'deactivated',
        defaultMessage: 'Deactivated',
    },
    invitations: {
        id: 'invitations',
        defaultMessage: 'Invitations',
    },
    role: {
        id: 'role',
        defaultMessage: 'Role',
    },
    statusActive: {
        id: 'active',
        defaultMessage: 'Active',
    },
    statusInactive: {
        id: 'inactive',
        defaultMessage: 'Inactive',
    },
    deleteInvitationFor: {
        id: 'delete-invitation-for',
        defaultMessage: 'Delete invitation for {email}',
    },
    deleteInvitation: {
        id: 'delete-invitation',
        defaultMessage: 'Delete invitation',
    },
    confirmDeleteInvitation: {
        id: 'confirm-delete-invitation',
        defaultMessage: 'Are you sure you want to delete the invitation for {email}? This action cannot be undone.',
    },
    deleteInvitationSuccess: {
        id: 'delete-invitation-success',
        defaultMessage: 'Invitation deleted',
    },
    deleteInvitationSuccessDetails: {
        id: 'delete-invitation-success-details',
        defaultMessage: 'Invitation for email {email} successfully deleted',
    },
    resendInvitation: {
        id: 'resend-invitation',
        defaultMessage: 'Resend invitation',
    },
    resendInvitationTo: {
        id: 'resend-invitation-to',
        defaultMessage: 'Resend invitation to {email}',
    },
    confirmResendInvitation: {
        id: 'confirm-resend-invitation',
        defaultMessage: 'Are you sure you want to resend the invitation for {email}?',
    },
    resendInvitationSuccess: {
        id: 'resend-invitation-success',
        defaultMessage: 'Invitation resent',
    },
    resendInvitationSuccessDetails: {
        id: 'resend-invitation-success-details',
        defaultMessage: 'Invitation for email {email} successfully resent',
    },
    invitedBy: {
        id: 'invited-by',
        defaultMessage: 'Invited by',
    },
    expires: {
        id: 'expires',
        defaultMessage: 'Expires',
    },
    invitation: {
        id: 'invitation',
        defaultMessage: 'Invitation',
    },
    invitationCreateSuccess: {
        id: 'invitation-create-success',
        defaultMessage: 'Invitation created',
    },
    invitationCreateSuccessDetails: {
        id: 'invitation-create-success-details',
        defaultMessage: 'Invitation successfully created for user with email {email}',
    },
    newUserDescription: {
        id: 'new-user-description',
        defaultMessage:
            'Creating an invitation will send an email to the provided recipient. After that the invitee will need to open the link and complete their registration.',
    },
    firstName: {
        id: 'first-name',
        defaultMessage: 'First name',
    },
    lastName: {
        id: 'last-name',
        defaultMessage: 'Last name',
    },
    invitationAlreadySent: {
        id: 'invitation-already-sent',
        defaultMessage: 'Invitation already sent!',
    },
    invitationAlreadyAccepted: {
        id: 'invitation-already-accepted',
        defaultMessage: 'Invitation already accepted!',
    },
});
